/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2025 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\router\index.js                                                  *
 * Project: cbs_comms_ai_frontend                                              *
 * Created Date: Thursday, February 20th 2025, 1:20:44 pm                      *
 * Author: Shri Kaanth <shrikaanth@codestax.ai>                                *
 * -----                                                                       *
 * Last Modified: July 25th 2025, 10:33:01 am                                  *
 * Modified By: Sankarra Narayanan G                                           *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

import { createRouter, createWebHistory } from "vue-router";
import PressRelease from "@/views/sideMenu/PressRelease.vue";
import NarrativeHome from "@/views/Narrative/NarrativeHome.vue";
import CreatePrSteps from "@/views/CreatePrSteps.vue";
import PrPlanHome from "@/views/PrPlan/PrPlanHome.vue";
import NarrativeGenerationStages from "@/views/Narrative/NarrativeGenerationStages.vue";
import GenerateMessageHouse from "@/views/MessageHouse/GenerateMessageHouse.vue";
import MessageHouseHome from "@/views/MessageHouse/MessageHouseHome.vue";
import PrPlanStages from "@/views/PrPlan/PrPlanDetails.vue";
import StoryBankHome from "@/views/StoryBank/StoryBankHome.vue";
import StoryBankDetails from "@/views/StoryBank/StoryBankDetails.vue";
import Login from "@/views/Login.vue";
import Signup from "@/views/Signup.vue";
import ArticleStages from "@/views/Article/ArticleStages.vue";
import ArticlesHome from "@/views/Article/ArticlesHome.vue";
import SocialStrategy from "@/views/SocialStrategy/SocialStrategy.vue";
import CrisisDetails from "@/views/CrisisManagement/CrisisDetails.vue";
import ManagePassword from "@/views/ManagePassword.vue";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import CrisisManagementHome from "@/views/CrisisManagement/CrisisManagementHome.vue";

const routes = [
    {
        path: "/",
        redirect: "/login",
        component: () => import("../components/Sidebar.vue"),
        children: [
            {
                path: "pr",
                name: "PressRelease",
                component: PressRelease,
                meta: { requiresAuth: true },
            },
            {
                path: "narratives",
                name: "NarrativeHome",
                component: NarrativeHome,
                meta: { requiresAuth: true },
            },
            {
                path: "messageHouse",
                name: "MessageHouseHome",
                component: MessageHouseHome,
                meta: { requiresAuth: true },
            },
            {
                path: "articles",
                name: "ArticleHome",
                component: ArticlesHome,
                meta: { requiresAuth: true },
            },
            {
                path: "prplan",
                name: "PrPlanHome",
                component: PrPlanHome,
                meta: { requiresAuth: true },
            },
            {
                path: "socialStrategy",
                name: "socialStrategy",
                component: SocialStrategy,
                meta: { requiresAuth: true },
            },
            {
                path: "storyBank",
                name: "storyBankHome",
                component: StoryBankHome,
                meta: { requiresAuth: true },
            },
            {
                path: "crisisManagement",
                name: "CrisisManagementHome",
                component: CrisisManagementHome,
                meta: { requiresAuth: true },
            },
        ],
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    // {
    //     path: "/manage-password",
    //     name: "ManagePassword",
    //     component: ManagePassword,
    //     beforeEnter: async (to, from, next) => {
    //         const mode = to.query.mode
    //         const oobCode = to.query.oobCode
    //         if (mode !== 'resetPassword' || !oobCode)
    //             return next(from.fullPath || '/login')
    //         const auth = getAuth()
    //         try {
    //             await verifyPasswordResetCode(auth, oobCode)
    //             next()
    //         } catch {
    //             alert('The password reset link is invalid or has expired.')
    //             next(from.fullPath || '/login')
    //         }
    //     },
    // },
    {
        path: "/pr/:prId",
        name: "PrDetails",
        component: CreatePrSteps,
        meta: { requiresAuth: true },
    },
    {
        path: "/narrative/:narrativeId",
        name: "NarrativeDetails",
        component: NarrativeGenerationStages,
        meta: { requiresAuth: true },
    },
    {
        path: "/article/:articleId",
        name: 'ArticleStages',
        component: ArticleStages,
        meta: { requiresAuth: true },
    },
    {
        path: "/prplan/:prCampaignId",
        name: "PrPlanDetails",
        component: PrPlanStages,
        meta: { requiresAuth: true },
    },
    {
        path: "/messageHouse/:msgHouseId",
        name: "MessageHouseDetails",
        component: GenerateMessageHouse,
        meta: { requiresAuth: true },
    },
    {
        path: "/social-strategy/:socialStrategyId",
        name: "SocialStrategyDetails",
        component: () => import("@/views/SocialStrategy/SocialStrategyDetails.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "/storyBank/:storyBankId",
        name: "StoryBankDetails",
        component: StoryBankDetails,
        meta: { requiresAuth: true },
    },
    {
        path: "/crisisManagement/:crisisDocumentId",
        name: "CrisisManagementDetails",
        component: CrisisDetails,
        meta: { requiresAuth: true },
    },

];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    const auth = getAuth()

    // Wait until Firebase finishes initializing
    const user = await new Promise(resolve => {
        const unsub = onAuthStateChanged(auth, user => {
            unsub()
            resolve(user)
        })
    })

    if (to.meta.requiresAuth && !user) next('/login')
    else if ((to.path === '/login' || to.path === '/') && user) next('/narratives')
    else next()
})

export default router;